import React from "react";
import PropTypes from "prop-types";
import { ButtonGroupComponent } from "./style";

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      onlyIcon = _ref.onlyIcon;
  return React.createElement(
    ButtonGroupComponent,
    { onlyIcon: onlyIcon },
    children
  );
};

ButtonGroup.propTypes = {
  /** Content of the button group. Should be two or more buttons. */
  children: PropTypes.any.isRequired,
  /** Use when all buttons are icons. */
  onlyIcon: PropTypes.bool
};

ButtonGroup.defaultProps = {
  onlyIcon: false
};

export default ButtonGroup;